const fontSize = {
  xs: "12px",
  s: "14px",
  m: "16px",
  l: "18px",
  xl: "24px",
  xxl: "32px",
};
export default fontSize;
